import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=0263f4dc&scoped=true"
import script from "./Size.vue?vue&type=script&lang=js"
export * from "./Size.vue?vue&type=script&lang=js"
import style0 from "./Size.vue?vue&type=style&index=0&id=0263f4dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0263f4dc",
  null
  
)

export default component.exports